import styled from 'styled-components';

export const Wrapper = styled.span`
  padding: 5px 8px;
  border-radius: 3px;
  cursor: pointer;
  user-select: none;

  ${(p) => p.theme.activeControlStyle}

  &.fill {
    background: ${(p) => p.theme.buttonFill};
  }

  &.yellow {
    color: ${(p) => p.theme.yellow};
  }

  &.block {
    display: block;
    padding: 10px 8px 12px;
    text-align: center;
  }

  &.inline {
    padding: 0;
  }

  &.disabled {
    cursor: default;
    opacity: 0.3;
    pointer-events: none;
  }
`;

export const Compensator = styled.div`
  margin: -5px -8px;
`;

export const SectionConstraints = styled.div`
  margin: 0 -8px 5px;
`;
